<template>
  <breadCrumbs title="Input Groups" main="Forms Controls" title1="Input Groups" />
  <div class="container-fluid">
            <div class="row">
              <input1/>
              <input2/>
            </div>
         </div>
</template>
<script>
import input1 from "./input1Page.vue"
import input2 from "./input2Page.vue"
export default {
    components:{
        input1,
        input2
    }
}
</script>